import React,{useState} from 'react'
import { LoginBoxContent } from '../../styles/Auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamationTriangle, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { useAuthRequests } from '../../helpers/AuthRequests';
import { useDispatch } from 'react-redux';
import { useCartRequests } from '../../helpers/CartRequests';
import { setBasket } from '../stores/Cart';
import { setCustomer, loginChange } from "../stores/Auth";
import { Bounce, Sentry } from 'react-activity';


export default function LoginBox({open,setOpen}) {
    
  const { loginRequest, getCustomer } = useAuthRequests();
  const {getCart}=useCartRequests();

  const dispatch = useDispatch();
  
  const [email,setEmail]=useState('')
  const [password,setPassword]=useState('')
  const [error,setError]=useState('')
  const [success,setSuccess]=useState('')
  const [loading,setLoading]=useState(false)
  const [checked,setChecked]=useState(false)

  const loginIn=async(e)=>{
    e.preventDefault();
    const debug=true
    if(loading){
      return
    }else if(email=='' || email.length<2 && debug==false){
      setError('Email adresinizi giriniz.')
    }else if(password=='' || password.length<6 && debug==false){
      setError('Şifrenizi giriniz.')
    }else{
      setLoading(true)

      loginRequest(email,password)
      .then( async(response)=> {
        setError("");
        setSuccess("Giriş işlemi başarılı lütfen bekleyiniz...");
        setEmail('')
        setPassword('')
        setChecked(false)
        localStorage.removeItem("conteynerroutes")
        dispatch(loginChange({
          token:response.data.data.authenticationKey,
          login:true,
        }))
        setTimeout(() => {
          getCustomer(response.data.data.authenticationKey).then((res) => {
            dispatch(setCustomer(res.data.data));
            setTimeout(() => {
              getCart().then((res) => {
                dispatch(setBasket(res.data.data));
              });
            }, 500);
            setTimeout(() => {
              // history.push('/')
              if (window.location.href.indexOf("localhost") != -1) {
                window.location = "http://localhost:3000";
                return;
              }
              window.location = process.env.REACT_APP_FRONT_URL;
            }, 3000);
          });
        }, 300);
        

      })
      .catch( (error)=> {
        setError(error.response.data.message)
        setLoading(false)
      })

      

    }

    
  }
  if(!open){
    return <></>;
  }
  return (
    <LoginBoxContent onClick={() => setOpen(false)}>
      <div className="box" onClick={(e) => e.stopPropagation()}>
        <div className="close" onClick={() => setOpen(false)}>
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <form autoComplete="off" onSubmit={loginIn}>
          <h1>Üye Girişi</h1>
          <div className="form-box">
            <input
              type="text"
              aria-autocomplete="both"
              aria-haspopup="false"
              autocapitalize="off"
              autocomplete="off"
              autocorrect="off"
              autofocus=""
              autoComplete="off"
              placeholder="E Posta"
              name="conteyner2"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-box">
            <input
              aria-autocomplete="both"
              aria-haspopup="false"
              autocapitalize="off"
              autocomplete="off"
              autocorrect="off"
              autofocus=""
              autoComplete="off"
              placeholder="Parola"
              type="password"
              name="conteyner"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <div className="error-area">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                style={{ marginRight: 20 }}
              />
              <span>{error}</span>
            </div>
          )}
          {success && (
            <div className="success-area">
              <FontAwesomeIcon icon={faCheck} style={{ marginRight: 20 }} />
              <span>{success}</span>
            </div>
          )}
          {loading == true ? (
            <Sentry size={20} color="green" />
          ) : (
            <button type="submit">Giriş Yap</button>
          )}
        </form>
      </div>
    </LoginBoxContent>
  );
}
